import React, { useState } from 'react';
import styles from "./index.module.scss"
import { CnIcon } from '@sto/cn-ui';

declare global {
  interface Window {
    wisdomStar?: {
      openAnswerPreview?: (docId: string, isTestChat: boolean) => void;
      openFilePreview?: (docId: string, docName: string) => void;
    };
  }
}

const HitKnowledge = ({ list, isTestChat, isAnnotation = false }) => {
  const [expend, setExpend] = useState(true);
  return list?.length ? (
    <div className={styles.hitKnowledge}>
      <div className={styles.header} onClick={() => setExpend((v) => !v)}>
        <span>共{list?.length}篇参考内容</span>
        <CnIcon type={expend ? 'arrow-up' : 'arrow-down'} size="medium" />
      </div>
      <ul className={styles.hitKnowledgeList} style={{ display: expend ? 'block' : 'none' }}>
        {list?.map(({ docName, docId, previewPcUrl, docTempUrl, type, fullCategoryName }, index) => (
          <li
            className={styles.hitKnowledgeItem}
            key={docId}
            onClick={() => {

              if (docId && type === 'knowledgeQuestion' && (window as any).wisdomStar?.openAnswerPreview) {
                (window as any).wisdomStar?.openAnswerPreview?.(docId, !!isTestChat);
                return;
              }
              if (docId && (window as any).wisdomStar?.openFilePreview) {
                (window as any).wisdomStar?.openFilePreview?.(docId, docName);
                return;
              }
              if (docTempUrl || previewPcUrl) {
                window.open(previewPcUrl || docTempUrl);
                return;
              }
            }}
          >
            <span className={styles.sort}>
              {index + 1}、
            </span>
            {docName}{isAnnotation && fullCategoryName && `【${fullCategoryName}】`}
          </li>
        ))}
      </ul>
    </div>
  ) : null
}

export default HitKnowledge;
